import React, {useContext, useEffect, useState} from "react";
import {directusContext} from "../../app/DirectusProvider";
import moment from "moment/moment";
import Presence from "../../app/config/Presence";
import Title from "../common/Title";
import {t} from "i18next";
import {loadSpinner} from "../../utils/helpers";

const CoursVueEnsemble = () => {
    const {directus} = useContext(directusContext);
    const [cours, setCours] = useState();

    const now = moment().format("Y-MM-DD");

    useEffect(() => {


        loadSpinner(
            new Promise((resolve, reject) => {
                directus.items("cours").readByQuery({
                    fields: ["groupe.nom", "enfants.enfant_id.prenom", "enfants.presence", "enfants.enfant_id.nom", "entraineurs.directus_users_id.first_name", "entraineurs.directus_users_id.last_name"],
                    filter: {'date': {'_gte': now}},
                    sort: ['date', 'groupe.numero']
                }).then((data) => {
                    setCours(data.data);
                    resolve();
                }).catch(() => {
                    reject("Une erreur est survenue");
                });
            })
        );
    }, [setCours]);

    if (!cours || cours?.length < 1)
        return null;

    return (
        <>
            <Title title={t("menu.vueEnsemble")}/>
            <div className={"grid grid-cols-1 md:grid-cols-4 p-1"}>

                {cours.map((c, i) => {
                    return (
                        <div key={`cours-${i}`}
                             className={"border-gray-200 border-1 border-solid border m-3 p-2 rounded shadow-xl"}>
                            <div className={"border-b-2 border-gray-200 mb-2 pb-2"}>
                                <h2 className={"text-2xl"}>{c.groupe.nom}</h2>
                                <div className={"text-xl"}>
                                    {c.entraineurs.map((e, j) => {
                                        return (
                                            <div key={`cours-${i}-entrainteur-${j}`} className={"inline"}>
                                                {e.directus_users_id.first_name} {e.directus_users_id.last_name}
                                                {j !== c.entraineurs.length - 1 ? " & " : ""}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            {c.enfants.filter((e) => {
                                return e.presence === Presence.present.value
                            }).map((e, j) => {
                                return (
                                    <div key={`cours-${i}-enfant-${j}`}>{e.enfant_id.prenom} {e.enfant_id.nom}</div>
                                )
                            })}
                        </div>
                    )
                })}
            </div>
        </>
    )
}

export default CoursVueEnsemble;